import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_RANGE_SELECTION_STRATEGY, MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { ButtonToggleSelectModule } from 'ngx-zcs-components';

import { MaxRangeDirective } from './max-picker-range.directive';
import { TelemetryReportComponent } from './telemetry-report.component';
import { MaxRangeSelectionStrategy } from './day-range-selection-strategy.util';
import { BlockTitleComponent } from '../components/block-title/block-title.component';

@NgModule({
  declarations: [
    TelemetryReportComponent,
  ],
  imports: [
    BlockTitleComponent,
    ButtonToggleSelectModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatSelectModule,
    MaxRangeDirective,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    }
  ],
  exports: [
    TelemetryReportComponent,
  ],
})
export class TelemetryReportModule { }
